import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-57ca8773"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "PlaneTurntableRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "根据提示判断图形对应的颜色", -1));
const _hoisted_4 = {
  class: "bothCenter mt16"
};
const _hoisted_5 = {
  class: "turntable"
};
const _hoisted_6 = ["width", "height", "viewBox"];
const _hoisted_7 = ["d", "fill"];
const _hoisted_8 = ["d"];
const _hoisted_9 = ["cx", "cy", "r"];
const _hoisted_10 = ["x", "y", "width", "height"];
const _hoisted_11 = ["points"];
const _hoisted_12 = ["points"];
const _hoisted_13 = ["cx", "cy", "r"];
const _hoisted_14 = {
  class: "clue"
};
const _hoisted_15 = {
  class: "clue-shape"
};
const _hoisted_16 = ["width", "height", "viewBox"];
const _hoisted_17 = ["cx", "cy", "r"];
const _hoisted_18 = ["x", "y", "width", "height"];
const _hoisted_19 = ["points"];
const _hoisted_20 = ["points"];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "clue-arrow"
}, "→", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请为剩余图形勾选正确颜色", -1));
const _hoisted_23 = {
  class: "answer-panel mt16"
};
const _hoisted_24 = {
  class: "shape-label"
};
const _hoisted_25 = {
  class: "clue-shape"
};
const _hoisted_26 = ["width", "height", "viewBox"];
const _hoisted_27 = ["cx", "cy", "r"];
const _hoisted_28 = ["x", "y", "width", "height"];
const _hoisted_29 = ["points"];
const _hoisted_30 = ["points"];
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "→", -1));
const _hoisted_32 = {
  class: "color-options"
};
const _hoisted_33 = ["disabled", "onClick"];
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "answer-hint"
}, "每种颜色只能使用一次，选满后可提交", -1));
const _hoisted_35 = {
  class: "review-group"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正确答案", -1));
const _hoisted_37 = {
  class: "review-pairs"
};
const _hoisted_38 = {
  class: "clue-shape"
};
const _hoisted_39 = ["width", "height", "viewBox"];
const _hoisted_40 = ["cx", "cy", "r"];
const _hoisted_41 = ["x", "y", "width", "height"];
const _hoisted_42 = ["points"];
const _hoisted_43 = ["points"];
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "clue-arrow"
}, "→", -1));
const _hoisted_45 = {
  key: 0,
  class: "review-group"
};
const _hoisted_46 = {
  key: 0,
  class: "review-pairs"
};
const _hoisted_47 = {
  class: "clue-shape"
};
const _hoisted_48 = ["width", "height", "viewBox"];
const _hoisted_49 = ["cx", "cy", "r"];
const _hoisted_50 = ["x", "y", "width", "height"];
const _hoisted_51 = ["points"];
const _hoisted_52 = ["points"];
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "clue-arrow"
}, "→", -1));
const _hoisted_54 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock("svg", {
    width: $options.size,
    height: $options.size,
    viewBox: `0 0 ${$options.size} ${$options.size}`,
    role: "img",
    "aria-label": "Plane Turntable"
  }, [_createElementVNode("g", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.outerSegments, seg => {
    return _openBlock(), _createElementBlock("path", {
      key: `outer_${seg.index}`,
      d: seg.path,
      fill: seg.color,
      stroke: "#ffffff",
      "stroke-width": "2"
    }, null, 8, _hoisted_7);
  }), 128))]), _createElementVNode("g", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.innerSegments, seg => {
    return _openBlock(), _createElementBlock("path", {
      key: `inner_${seg.index}`,
      d: seg.path,
      fill: "#f7f7f7",
      stroke: "#e6e6e6",
      "stroke-width": "2"
    }, null, 8, _hoisted_8);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.innerSegments, seg => {
    return _openBlock(), _createElementBlock("g", {
      key: `shape_${seg.index}`
    }, [seg.shape === 'Circle' ? (_openBlock(), _createElementBlock("circle", {
      key: 0,
      cx: seg.iconX,
      cy: seg.iconY,
      r: $options.iconSize,
      fill: "#4a4a4a"
    }, null, 8, _hoisted_9)) : seg.shape === 'Square' ? (_openBlock(), _createElementBlock("rect", {
      key: 1,
      x: seg.iconX - $options.iconSize,
      y: seg.iconY - $options.iconSize,
      width: $options.iconSize * 2,
      height: $options.iconSize * 2,
      fill: "#4a4a4a"
    }, null, 8, _hoisted_10)) : seg.shape === 'Triangle' ? (_openBlock(), _createElementBlock("polygon", {
      key: 2,
      points: $options.trianglePoints(seg.iconX, seg.iconY, $options.iconSize),
      fill: "#4a4a4a"
    }, null, 8, _hoisted_11)) : (_openBlock(), _createElementBlock("polygon", {
      key: 3,
      points: $options.starPoints(seg.iconX, seg.iconY, $options.iconSize, $options.iconSize * 0.5),
      fill: "#4a4a4a"
    }, null, 8, _hoisted_12))]);
  }), 128))]), _createElementVNode("circle", {
    cx: $options.cx,
    cy: $options.cy,
    r: $options.innerHole,
    fill: "#ffffff"
  }, null, 8, _hoisted_13)], 8, _hoisted_6)), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(), _createElementBlock("svg", {
    width: $options.clueSize,
    height: $options.clueSize,
    viewBox: `0 0 ${$options.clueSize} ${$options.clueSize}`,
    "aria-hidden": "true"
  }, [$props.data.clueShape === 'Circle' ? (_openBlock(), _createElementBlock("circle", {
    key: 0,
    cx: $options.clueSize / 2,
    cy: $options.clueSize / 2,
    r: $options.clueSize * 0.28,
    fill: "#4a4a4a"
  }, null, 8, _hoisted_17)) : $props.data.clueShape === 'Square' ? (_openBlock(), _createElementBlock("rect", {
    key: 1,
    x: $options.clueSize * 0.22,
    y: $options.clueSize * 0.22,
    width: $options.clueSize * 0.56,
    height: $options.clueSize * 0.56,
    fill: "#4a4a4a"
  }, null, 8, _hoisted_18)) : $props.data.clueShape === 'Triangle' ? (_openBlock(), _createElementBlock("polygon", {
    key: 2,
    points: $options.trianglePoints($options.clueSize / 2, $options.clueSize / 2, $options.clueSize * 0.28),
    fill: "#4a4a4a"
  }, null, 8, _hoisted_19)) : (_openBlock(), _createElementBlock("polygon", {
    key: 3,
    points: $options.starPoints($options.clueSize / 2, $options.clueSize / 2, $options.clueSize * 0.28, $options.clueSize * 0.14),
    fill: "#4a4a4a"
  }, null, 8, _hoisted_20))], 8, _hoisted_16))]), _hoisted_21, _createElementVNode("div", {
    class: "clue-color",
    style: _normalizeStyle({
      background: $options.colorMap[$props.data.clueColor] || $props.data.clueColor
    })
  }, null, 4)])])]), _createVNode(_component_el_row, {
    class: "bothCenter mt24"
  }, {
    default: _withCtx(() => [_hoisted_22]),
    _: 1
  }), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.answerableShapes, shape => {
    return _openBlock(), _createElementBlock("div", {
      key: `shape_row_${$props.data.questionIndex}_${shape}`,
      class: "answer-row"
    }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [(_openBlock(), _createElementBlock("svg", {
      width: $options.clueSize,
      height: $options.clueSize,
      viewBox: `0 0 ${$options.clueSize} ${$options.clueSize}`,
      "aria-hidden": "true"
    }, [shape === 'Circle' ? (_openBlock(), _createElementBlock("circle", {
      key: 0,
      cx: $options.clueSize / 2,
      cy: $options.clueSize / 2,
      r: $options.clueSize * 0.28,
      fill: "#4a4a4a"
    }, null, 8, _hoisted_27)) : shape === 'Square' ? (_openBlock(), _createElementBlock("rect", {
      key: 1,
      x: $options.clueSize * 0.22,
      y: $options.clueSize * 0.22,
      width: $options.clueSize * 0.56,
      height: $options.clueSize * 0.56,
      fill: "#4a4a4a"
    }, null, 8, _hoisted_28)) : shape === 'Triangle' ? (_openBlock(), _createElementBlock("polygon", {
      key: 2,
      points: $options.trianglePoints($options.clueSize / 2, $options.clueSize / 2, $options.clueSize * 0.28),
      fill: "#4a4a4a"
    }, null, 8, _hoisted_29)) : (_openBlock(), _createElementBlock("polygon", {
      key: 3,
      points: $options.starPoints($options.clueSize / 2, $options.clueSize / 2, $options.clueSize * 0.28, $options.clueSize * 0.14),
      fill: "#4a4a4a"
    }, null, 8, _hoisted_30))], 8, _hoisted_26))]), _hoisted_31]), _createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.selectableColors, color => {
      return _openBlock(), _createElementBlock("button", {
        key: `color_${shape}_${color}`,
        type: "button",
        class: _normalizeClass(["color-choice", {
          active: $data.selectedColors[shape] === color,
          disabled: $options.isColorDisabled(shape, color)
        }]),
        disabled: $props.reviewMode || $options.isColorDisabled(shape, color),
        onClick: $event => $options.chooseColor(shape, color)
      }, [_createElementVNode("span", {
        class: "color-dot",
        style: _normalizeStyle({
          background: $options.colorMap[color] || color
        })
      }, null, 4), _createElementVNode("span", null, _toDisplayString($options.colorLabelMap[color] || color), 1)], 10, _hoisted_33);
    }), 128))])]);
  }), 128))]), !$props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter mt12"
  }, {
    default: _withCtx(() => [_hoisted_34]),
    _: 1
  })) : _createCommentVNode("", true), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "review-sections mt16"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parseAnswerPairs($props.data.rightAnswer), (pair, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: `right_pair_${index}`,
        class: "review-pair"
      }, [_createElementVNode("div", _hoisted_38, [(_openBlock(), _createElementBlock("svg", {
        width: $options.clueSize,
        height: $options.clueSize,
        viewBox: `0 0 ${$options.clueSize} ${$options.clueSize}`,
        "aria-hidden": "true"
      }, [pair.shape === 'Circle' ? (_openBlock(), _createElementBlock("circle", {
        key: 0,
        cx: $options.clueSize / 2,
        cy: $options.clueSize / 2,
        r: $options.clueSize * 0.28,
        fill: "#4a4a4a"
      }, null, 8, _hoisted_40)) : pair.shape === 'Square' ? (_openBlock(), _createElementBlock("rect", {
        key: 1,
        x: $options.clueSize * 0.22,
        y: $options.clueSize * 0.22,
        width: $options.clueSize * 0.56,
        height: $options.clueSize * 0.56,
        fill: "#4a4a4a"
      }, null, 8, _hoisted_41)) : pair.shape === 'Triangle' ? (_openBlock(), _createElementBlock("polygon", {
        key: 2,
        points: $options.trianglePoints($options.clueSize / 2, $options.clueSize / 2, $options.clueSize * 0.28),
        fill: "#4a4a4a"
      }, null, 8, _hoisted_42)) : (_openBlock(), _createElementBlock("polygon", {
        key: 3,
        points: $options.starPoints($options.clueSize / 2, $options.clueSize / 2, $options.clueSize * 0.28, $options.clueSize * 0.14),
        fill: "#4a4a4a"
      }, null, 8, _hoisted_43))], 8, _hoisted_39))]), _hoisted_44, _createElementVNode("div", {
        class: "clue-color",
        style: _normalizeStyle({
          background: $options.colorMap[pair.color] || pair.color
        })
      }, null, 4)]);
    }), 128))])]), $props.review ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("span", {
      style: _normalizeStyle({
        color: $props.review.result ? '#27ae60' : '#e74c3c'
      })
    }, " 您的答案 ", 4), $options.isMappingAnswer($props.review.answer) ? (_openBlock(), _createElementBlock("div", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parseAnswerPairs($props.review.answer), (pair, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: `user_pair_${index}`,
        class: "review-pair"
      }, [_createElementVNode("div", _hoisted_47, [(_openBlock(), _createElementBlock("svg", {
        width: $options.clueSize,
        height: $options.clueSize,
        viewBox: `0 0 ${$options.clueSize} ${$options.clueSize}`,
        "aria-hidden": "true"
      }, [pair.shape === 'Circle' ? (_openBlock(), _createElementBlock("circle", {
        key: 0,
        cx: $options.clueSize / 2,
        cy: $options.clueSize / 2,
        r: $options.clueSize * 0.28,
        fill: "#4a4a4a"
      }, null, 8, _hoisted_49)) : pair.shape === 'Square' ? (_openBlock(), _createElementBlock("rect", {
        key: 1,
        x: $options.clueSize * 0.22,
        y: $options.clueSize * 0.22,
        width: $options.clueSize * 0.56,
        height: $options.clueSize * 0.56,
        fill: "#4a4a4a"
      }, null, 8, _hoisted_50)) : pair.shape === 'Triangle' ? (_openBlock(), _createElementBlock("polygon", {
        key: 2,
        points: $options.trianglePoints($options.clueSize / 2, $options.clueSize / 2, $options.clueSize * 0.28),
        fill: "#4a4a4a"
      }, null, 8, _hoisted_51)) : (_openBlock(), _createElementBlock("polygon", {
        key: 3,
        points: $options.starPoints($options.clueSize / 2, $options.clueSize / 2, $options.clueSize * 0.28, $options.clueSize * 0.14),
        fill: "#4a4a4a"
      }, null, 8, _hoisted_52))], 8, _hoisted_48))]), _hoisted_53, _createElementVNode("div", {
        class: "clue-color",
        style: _normalizeStyle({
          background: $options.colorMap[pair.color] || pair.color
        })
      }, null, 4)]);
    }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString($props.review.answer), 1))])) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}